import { render, staticRenderFns } from "./AccessoryNewlyadded.vue?vue&type=template&id=0f936798&scoped=true&"
import script from "./AccessoryNewlyadded.vue?vue&type=script&lang=js&"
export * from "./AccessoryNewlyadded.vue?vue&type=script&lang=js&"
import style0 from "./AccessoryNewlyadded.vue?vue&type=style&index=0&id=0f936798&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f936798",
  null
  
)

export default component.exports